<template>
  <v-container class="contenedor">
        <!-- INFORMACION TOOLBAR  -->
        <v-card elevation="4" class="mb-5">
            <v-toolbar flat elevation="4">
                <v-card class="icon">
                    <v-icon
                        style="margin-left: 30px; margin-top: 25px"
                        color="white"
                        x-large=""
                        >mdi-fingerprint</v-icon
                    >
                </v-card>
            <div class="usuario">REGISTRAR INICIO TURNO</div>
           
            </v-toolbar>
        </v-card>
        <br />

        <v-col>
            <v-tabs
                v-model="generalTab"
                background-color="#FFFF"
                centered
                style="white"
                dark
                grow=""
                icons-and-text
            >
            <v-tabs-slider></v-tabs-slider>

            <v-tab v-for="(item, i) in itemTabs" :key="i">
                {{ item.title }}
                <v-icon>{{ item.icon }}</v-icon>
            </v-tab>

            <v-tab-item v-model="generalTab">
                <v-data-table
                    :headers="headers"
                    :items="informacionCartera"
                    :search="search"
                    class="elevation-3"
                >
                <template v-slot:no-data>
                    <v-alert
                    :value="true"
                    color="gray"
                    icon="mdi-sync-alert"
                    outlined
                    >No hay información para mostrar</v-alert
                    >
                </template>
                </v-data-table>
            </v-tab-item>
            </v-tabs>
        </v-col>
    <v-overlay :value="sisi">
      <div class="loader"></div>
    </v-overlay>
    <div>
      
      <div>
        <div v-if="puntoVentaEncontrado" class="mensaje">
          <h1 class=".h1b">{{ mensajePuntoVenta }}</h1>
        </div>
        <div v-else class="mensaje-error">
          <h1 class=".h1b">EQUIPO NO REGISTRADO o FALTA TRAYICON</h1>
          <p>COMUNICARSE CON EL ADMINISTRADOR DEL SISTEMA</p>
        </div>
        <div v-if="mensajeTrayIcon">{{ mensajeTrayIcon }}</div>
      </div>


      <div v-if="mostrarParaConsulta" text-align:center>  
        <input type="number" v-model.number="cedula" @keyup.enter="consultarCedula" placeholder="Ingrese la cédula">
        <button @click="consultarCedula" class="button">Consultar</button>
      </div>

      <div>
        <div v-if="mostrarDatos">
          <p class="mensaje">Nombre: {{ nombreUsuario }}</p>
          <p v-if="!tieneHuella" class="mensaje-error">SIN BIOMETRIA LLAMAR A SOPORTE</p>
          <p v-if="tieneHuella" class="mensaje">DAR CLIC PARA REGISTRAR FINAL DEL TURNO</p>
          <button v-if="tieneHuella" @click="capturarHuella" class="button">REGISTRAR INICIO TURNO</button>
        </div>
        <p v-if="errorConsulta" class="mensaje-error">{{ errorConsulta }}</p>
        <p v-if="huellaGuardada" class="mensaje">{{ mensajeHuella }}</p>
        <div v-if="mensaje" class="mensaje">{{ mensaje }}</div>
        <div v-if="mensajeError" class="mensaje-error">{{ mensajeError }}</div>
      </div>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import env from "../../env";

export default {
  data() {
    return {
      sisi: false,
      mensajePuntoVenta: '',
      mostrarParaConsulta: false,
      puntoVentaEncontrado: false,
      mensajeTrayIcon: '', // Agregar esta propiedad
      codigoseta: '',// Variable para almacenar codigoseta
      cedula: '',
      mostrarDatos: false,
      nombreUsuario: '',
      tieneHuella: false,
      errorConsulta: '',
      huellaGuardada: false,
      mensajeError: '',
      mensajeHuella: ''
    };
  },
  mounted() {    
// Extraer el parámetro 'id' de la URL
const urlParams = new URLSearchParams(window.location.search);
const id = urlParams.get('id');
console.log('ID extraído de la URL:', id);
// Almacenar el 'id' en el localStorage
localStorage.setItem('id', id);

  
    this.consultarMac();
  },
  methods: {
    consultarMac() {

      this.sisi = true;
      axios.get('http://127.0.0.1:9494/mac' )
        .then(response => {
          if (response.data.length === 0) {
            this.sisi = false;
            this.mostrarMensajeTrayicon('Falta abrir TrayIcon');
          } else {
            this.sisi = false;
            this.consultarDatos(response.data);
          }
        })
        .catch(error => {
          this.sisi = false;
          console.error('Error al consultar la dirección MAC:', error);
          this.mostrarMensajeTrayicon('Falta abrir TrayIcon');
        });
    },
    consultarDatos(macAddresses) {
      macAddresses.forEach(mac => {
        if (!this.puntoVentaEncontrado) {
          this.consultarPorMac(mac);
        }
      });
    },
    consultarPorMac(mac) {
      if (!this.puntoVentaEncontrado) {
        axios.get(`${env.endpoint}VisitasNew/ConsultaxMac?mac=${mac}`)
          .then(response => {
            if (response.data.error) {
              //console.error(response.data.error);
              //this.mensajePuntoVenta = 'Punto de venta no registrado, comunicarse con el administrador del sistema';
            } else {
              console.log(response.data.nombre);
              this.mensajePuntoVenta = `Punto de venta: ${response.data.nombre}`;
              this.puntoVentaEncontrado = true; // Marcar que se encontró un punto de venta
              this.mostrarParaConsulta = true;
              this.codigoseta = response.data.codigoseta; // Almacenar codigoseta
            }
          })
          .catch(error => {
            console.error('Error al consultar el punto de venta:', error);
          });
      }
    },
    mostrarMensajeTrayicon() {
      console.log('Abrir trayicon');
    },
    consultarCedula() {
      this.sisi = true;
      this.mensajeHuella = '';
      axios.get(`${env.endpoint}VisitasNew/ConsultarCedula?cedula=${this.cedula}`)
        .then(response => {
          if (response.data.error) {
            this.nombreUsuario = '';
            this.sisi = false;
            this.mensajeError = '';
            
            this.tieneHuella = false;
            this.errorConsulta = response.data.error;
            this.mostrarDatos = false; // Ocultar los datos si la cédula no se encuentra
          } else {
            this.nombreUsuario = response.data.nombre;
            this.tieneHuella = response.data.tieneHuella;
            this.mensajeError = '';
            this.sisi = false;
            this.mostrarDatos = true;
            this.errorConsulta = ''; // Limpiar el mensaje de error
          }
        })
        .catch(error => {
          this.sisi = false;
          console.error('Error al consultar la cédula:', error);
          this.errorConsulta = 'Error al consultar la cédula';
        });
    },
    capturarHuella() {
          this.sisi = true;
          this.mensajeHuella = '';
          this.mensajeError = '';
      fetch('http://127.0.0.1:9494/biometrico/')
        .then(response => {
          if (!response.ok) {
            this.sisi = false;
            return response.json().then(data => {
              throw new Error(data.error || 'Error en la comunicación con el lector de huellas.');
            });
          }
          return response.text();
        })
        .then(data => {
          const partes = data.split('|');
          if (partes.length >= 2) {
            const captura = partes[1];
            this.compararHuella(captura, `captura_${this.cedula}.bin`);
            this.sisi = false;
          } else {
            this.sisi = false;
            console.error('No se encontró el texto entre "|"');
            this.mensajeHuella = 'Error al capturar la huella biométrica';
          }
        })
        .catch(error => {
          this.sisi = false;
          console.error('Error al capturar la huella biométrica:', error.message);
          this.mensajeError = error.message;
        });
    },
    compararHuella(huella, nombreArchivo) {
    const formData = new FormData();
    formData.append('cedula', this.cedula);
    formData.append('huella', new Blob([huella], { type: 'application/octet-stream' }), nombreArchivo);
    formData.append('codigoseta', this.codigoseta); // Agregar codigoseta
    //formData.append('idusuario', localStorage.getItem('id'));

    console.log(this.cedula);
    axios.post(`${env.endpoint}VisitasNew/CompararHuella3`, formData)
        .then(response => {
            console.log('Respuesta del servidor:', response.data);
            if (response.data.success) {
                this.huellaGuardada = true;
                this.mensajeHuella = 'Registro Exitoso';
                this.mensajeError = '';
            } else {
                //this.mensajeHuella = response.data.message;
                this.mensajeError = response.data.message;
            }
        })
        .catch(error => {
            console.error('Error al enviar la huella biométrica1:', error);
            this.mensajeHuella = 'Error al enviar la huella biométrica2';
        });
}

  }
}
</script>

<style scoped>
.h1b {
  font-family: Arial, sans-serif;
  font-size: 24px;
  color: #2b2d74;
  text-align: center;
}


.button {
  background-color: #215f7e;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}

.mensaje {
  margin-top: 10px;
  padding: 10px;
  background-color: #f2f2f2;
  border: 1px solid #ccc;
  color: #070a36;
}

.mensaje-error {
  margin-top: 10px;
  padding: 10px;
  background-color: #ffcccc;
  border: 1px solid #ff0000;
  color: #070a36;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
.contenedor-ppalB {
  display: flex;
  justify-content: center; /* Centrar horizontalmente */
  align-items: center; /* Centrar verticalmente */
  height: 50vh; /* Ajustar altura al 100% del viewport */
  margin: 20px;
  border: 2px solid #070a36;
}

.content {
  text-align: center; /* Alinear contenido al centro */
}

</style>
